document.addEventListener('scroll', (event) => {
  scrollPosition = window.scrollY;
  const { body } = document;
  if (scrollPosition >= 120) {
    if (!body.classList.contains('scrolled')) {
      body.classList.add('scrolled');
    }
  } else if (scrollPosition == 0 && scrollPosition <= 200) {
    if (body.classList.contains('scrolled')) {
      body.classList.remove('scrolled');
    }
  }
});
